import React, { useEffect } from 'react';
import Banner from '@atlaskit/banner';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { ExportJSONTypes } from '@atlassian/temp-proxies';
import { removeAllSearchParams } from '@css-xp/ppc-utils';
import { AnalyticsForDownloadedAction, useExportJSON } from '@css-xp/ppc-custom-hooks';

export interface DownloadJSONBannerProps {
  id: string;
  transactionAccountId: string;
  isJsonAvailable: boolean;
  type: ExportJSONTypes;
  isJsonDownloaded?: boolean;
  analyticsForDownloadedAction: AnalyticsForDownloadedAction;
}

const BannerText = styled.span`
  margin-right: ${token('space.050', '4px')};
`;

export const DownloadJSONBanner = (props: DownloadJSONBannerProps) => {
  const { id, transactionAccountId, isJsonAvailable, type, isJsonDownloaded, analyticsForDownloadedAction } = props;
  const [isOpen, setIsOpen] = React.useState(true);
  const { downloadJSON, isCompleted } = useExportJSON({
    type,
    id,
    transactionAccountId,
    analyticsForDownloadedAction,
  });

  const handleDownloadJson = () => {
    downloadJSON();
    removeAllSearchParams();
  };

  useEffect(() => {
    if (isJsonDownloaded || isCompleted) {
      setIsOpen(false);
    }
  }, [isJsonDownloaded, isCompleted]);

  return (
    <Banner appearance={'announcement'} isOpen={isOpen && isJsonAvailable} testId="download-json-banner">
      <BannerText>The JSON file is ready.</BannerText>
      <a role="button" href="#" onClick={handleDownloadJson} data-testId="download-now" rel="noreferrer">
        Download now
      </a>
    </Banner>
  );
};
